<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
      />
      <path
        fill="currentColor"
        d="M16.5 12a4.5 4.5 0 0 1 .212 8.995L16.5 21h-9a4.5 4.5 0 0 1-.212-8.995L7.5 12zm0 2h-9a2.5 2.5 0 0 0-.164 4.995L7.5 19h9a2.5 2.5 0 0 0 .164-4.995zm-9 1a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m9-13a4.5 4.5 0 0 1 .212 8.995L16.5 11h-9a4.5 4.5 0 0 1-.212-8.995L7.5 2zm0 2h-9a2.5 2.5 0 0 0-.164 4.995L7.5 9h9a2.5 2.5 0 0 0 .164-4.995zm0 1a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"
      />
    </g>
  </svg>
</template>
